import {
    FETCH_ALL_PACK_SUCCESS, EDIT_PACK, UPDATE_PACK_SUCCESS, CREATE_PACK_SUCCESS, DELETE_PACK_SUCCESS,SET_PACK,SET_ROLE
} from "constants/packs.constants";

const INIT_STATE = {
    packs: [],
    pack_roles:[],
    pack: {
        id: 0,
        name: '',
       
        end_date:'',
        start_date:'',
        package_specialities:[],
        package_features:[],
        package_subscriptions:[],
        package_countries:[],
        countries:[],
        package_payment_methods:[]
    }
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.pack);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                pack:c
            }
        }
        //set pack
        case SET_PACK: {
            let c = Object.assign({}, state.pack);
            c[action.key] = action.value
            return {
                ...state,
                pack: c
            }
        }
        case FETCH_ALL_PACK_SUCCESS: {
            return {
                ...state,
                packs: action.payload.data,
                pagination: action.payload.page
            }
        }

        case UPDATE_PACK_SUCCESS: {
            let foundIndex = state.packs.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.packs);
            let o =  action.payload.data
            all[foundIndex] = o
            return {
                ...state,
                packs: all,
                pack: o,
            }
        }

        case CREATE_PACK_SUCCESS: {
            let all = Object.assign([], state.packs);
            all.push(action.payload.data)
            return {
                ...state,
                packs: all,
                pack: INIT_STATE.pack
            }
        }

        case DELETE_PACK_SUCCESS: {
            let all = Object.assign([], state.packs);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                packs: newArray,
            }
        }

        case EDIT_PACK: {
            let u = state.packs.find(c => c.id === action.payload)
            let o = Object.assign({}, u)
        
           // o.country_id = o.country.id
           // o.pack_type_id = o.partner_type.id
            return {
                ...state,
                pack: o
            }
        }

        

        
        default:
            return state;
    }
}